import * as THREE from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader'
import GameSceneRace from './GameSceneRace';

class Bird {
	
	sceneRootObject: THREE.Object3D;
	gameSceneRace: GameSceneRace;
	
	birds: THREE.Group = null!; 

	mixer: any = null!;
    clock;
    
    timeChangeDestination = 0;
    
    dx = 0;
    dz = 0;

	constructor(sceneRootObject: THREE.Object3D, gameSceneRace: GameSceneRace) {
		
		
		this.clock = new THREE.Clock();  

		this.gameSceneRace = gameSceneRace; 

		this.sceneRootObject = sceneRootObject;
		
        const loader = new GLTFLoader()
        loader.load('models/birds.glb', (gltf) => {
			
				
				this.sceneRootObject.add(gltf.scene);				
			
				this.birds = gltf.scene;

				this.birds.scale.x = 25;
				this.birds.scale.y = 25;
				this.birds.scale.z = 25;
				
				this.birds.position.x = this.gameSceneRace.car.getPhysBodyPosition().x + this.gameSceneRace.prng() * 200 - 100; 
				this.birds.position.y = this.gameSceneRace.car.getPhysBodyPosition().z + this.gameSceneRace.prng() * 200 - 100; 
				
				if (!this.gameSceneRace.isPlayerPlace) {
					this.birds.position.y = 150;
				} else {
					this.birds.position.y = 210;
				}

				this.mixer = new THREE.AnimationMixer(gltf.scene);
				
				const clip = this.mixer.clipAction(gltf.animations[0], gltf.scene);
				clip.play();

            },
            (xhr) => {
                console.log((xhr.loaded / xhr.total) * 100 + '% loaded')
            },
            (error) => {
                console.log(error)
            }
        )
		
	}
	/////////////////////////////////////////////////////////
	/////////////////////////////////////////////////////////
	/////////////////////////////////////////////////////////
	animate() {
		
		if (this.birds == null) {
			return;
		}
		
		//this.birds.animations[0].
		if (this.mixer != null) {
			this.mixer.update(this.clock.getDelta());
		}
		
		
		const time = Date.now();
		
		if (time > this.timeChangeDestination) {
			
			const destX = this.gameSceneRace.car.getPhysBodyPosition().x + this.gameSceneRace.prng() * 200 - 300; 
			const destZ = this.gameSceneRace.car.getPhysBodyPosition().z + this.gameSceneRace.prng() * 200 - 300; 
			
			const interval = this.gameSceneRace.prng() * 20000;
			
			const v = new THREE.Vector3(destX - this.birds.position.x, 0, destZ - this.birds.position.z).normalize();
			this.dx = v.x; 
			this.dz = v.z;

			// заставляем смотреть в сторону движения
			this.birds.lookAt(new THREE.Vector3(destX, this.birds.position.y, destZ));
			this.birds.rotateY(Math.PI);
			
			this.timeChangeDestination = time + interval;
		}
		
		this.birds.position.x += this.dx;
		this.birds.position.z += this.dz;
		
		
		
				
	}
	/////////////////////////////////////////////////////////
	
}
export default Bird;